export const USER_INFO = 'user_info';
export const ESR_BADGE = 'esr_badge';
